import { type IV2GetMetaResponseSchema } from '@/repositories/generated/shared/search-offers-index/entities/get_meta/V2GetMetaResponseSchema';

import { type ISearchMeta } from '@/microfrontends/filters/shared/types/searchMeta';

export function prepareSearchMetaData(response: IV2GetMetaResponseSchema): ISearchMeta {
  return {
    count: response.data.count,
    fullUrl: response.data.fullUrl,
    queryString: response.data.fullUrlWithoutSeo.substring(response.data.fullUrlWithoutSeo.indexOf('?' + 1)),
    h1: response.data.h1,
  };
}
